export default __webpack_public_path__ + "images/15e092b5e50bd3cdacc0b6b6a86557a8-sports.webp";